import HttpClient from 'services/HttpClient'
import {
  AIPricingModelDto,
  CreatePricingModelPayload,
  SetPricingModelActivePayload,
  UpdatePricingModelPayload} from 'types/aiAnalytics'

export class AiPricingModelsRepository {
  api: typeof HttpClient

  constructor(api: typeof HttpClient) {
    this.api = api
  }

  getAllPricingModels(
    activeOnly?: boolean
  ): Promise<{ data: AIPricingModelDto[] }> {
    const queryParams = activeOnly ? '?active=true' : ''

    return this.api.get(`/ai-pricing-models${queryParams}`)
  }

  getPricingModelById(id: string): Promise<{ data: AIPricingModelDto }> {
    return this.api.get(`/ai-pricing-models/${id}`)
  }

  createPricingModel(
    payload: CreatePricingModelPayload
  ): Promise<{ data: AIPricingModelDto }> {
    return this.api.post('/ai-pricing-models', payload)
  }

  updatePricingModel(
    id: string,
    payload: UpdatePricingModelPayload
  ): Promise<{ data: AIPricingModelDto }> {
    return this.api.put(`/ai-pricing-models/${id}`, payload)
  }

  deletePricingModel(id: string): Promise<{ data: { message: string } }> {
    return this.api.delete(`/ai-pricing-models/${id}`)
  }

  setActive(
    id: string,
    payload: SetPricingModelActivePayload
  ): Promise<{ data: AIPricingModelDto }> {
    return this.api.put(`/ai-pricing-models/${id}/active`, payload)
  }
}

export default new AiPricingModelsRepository(HttpClient)
